export default __webpack_public_path__ + "static/media/spratt1.7e1abe5c.jpg";